<div class="card">
  <div class="card-body">
    <div class="card-title"><h2>Usuario Arrendador</h2></div>
    <!-- Row -->
<div class="row">

   <!-- Column -->
   <div class="col-lg-6 col-md-6 col-sm-6">
    <div class="card card-inverse" style="background-color: rgb(88, 190, 83);">
        <div class="card-body">
            <div class="d-flex">
                <div class="m-r-20 align-self-center">
                    <h1 class="text-white"><i class="ti-unlock"></i></h1></div>
                <div>
                  <a routerLink="/arrendador-usuario"><h3 class="card-title">Usuarios Arrendadores Activados</h3></a>
                    <h1 class="card-subtitle" style="text-align: end;">{{totalArrendadoresActivados}}</h1> </div>
            </div>
        </div>
    </div>
</div>
<!-- Column -->

 <!-- Column -->
 <div class="col-lg-6 col-md-6 col-sm-6">
  <div class="card card-inverse" style="background-color: rgb(238, 103, 88);">
      <div class="card-body">
          <div class="d-flex">
              <div class="m-r-20 align-self-center">
                  <h1 class="text-white"><i class="ti-lock"></i></h1></div>
              <div>
                <a routerLink="/arrendador-usuario"><h3 class="card-title">Usuarios Arrendadores Desactivados</h3></a>
                  <h1 class="card-subtitle" style="text-align: end;">{{totalArrendadoresDesactivados}}</h1> </div>
          </div>
      </div>
  </div>
</div>
<!-- Column -->
</div>
<!-- Row -->

  </div>
</div>


<div class="card">
  <div class="card-body">
    <div class="card-title"><h2>Usuario Arrendatario</h2></div>
    <!-- Row -->
<div class="row">

   <!-- Column -->
   <div class="col-lg-6 col-md-6 col-sm-6">
    <div class="card card-inverse" style="background-color: rgb(88, 190, 83);">
        <div class="card-body">
            <div class="d-flex">
                <div class="m-r-20 align-self-center">
                    <h1 class="text-white"><i class="ti-unlock"></i></h1></div>
                <div>
                  <a routerLink="/arrendatario-usuario"><h3 class="card-title">Usuarios Arrendatarios Activados</h3></a>
                    <h1 class="card-subtitle" style="text-align: end;">{{totalArrendatariosActivados}}</h1> </div>
            </div>
        </div>
    </div>
</div>
<!-- Column -->

 <!-- Column -->
 <div class="col-lg-6 col-md-6 col-sm-6">
  <div class="card card-inverse" style="background-color: rgb(238, 103, 88);">
      <div class="card-body">
          <div class="d-flex">
              <div class="m-r-20 align-self-center">
                  <h1 class="text-white"><i class="ti-lock"></i></h1></div>
              <div>
                <a routerLink="/arrendatario-usuario"><h3 class="card-title">Usuarios Arrendatarios Desactivados</h3></a>
                  <h1 class="card-subtitle" style="text-align: end;">{{totalArrendatariosDesactivados}}</h1> </div>
          </div>
      </div>
  </div>
</div>
<!-- Column -->
</div>
<!-- Row -->

  </div>
</div>



<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <div >
          <div class="card-title"><h2>Mensajes no leídos</h2></div>
          <!-- Row -->
      <div class="row">

         <!-- Column -->
         <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="card card-inverse" style="background-color: rgb(252, 46, 0);">
              <div class="card-body">
                  <div class="d-flex">
                      <div class="m-r-20 align-self-center">
                          <h1 class="text-white"><i class="ti-comment-alt"></i></h1></div>
                      <div>
                        <a routerLink="/mensajes"><h3 class="card-title">Mensajes recibidos</h3></a>
                          <h1 class="card-subtitle" style="text-align: end;">{{mensajesNoLeidos}}</h1> </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- Column -->
      </div>
      <!-- Row -->

        </div>
      </div>

      <div class="col-lg-6">
        <div>
          <div class="card-title"><h2>Servicios básicos</h2></div>
          <!-- Row -->
      <div class="row">

         <!-- Column -->
         <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="card card-inverse" style="background-color: rgb(41, 151, 202);">
              <div class="card-body">
                  <div class="d-flex">
                      <div class="m-r-20 align-self-center">
                          <h1 class="text-white"><i class="ti-settings"></i></h1></div>
                      <div>
                        <a routerLink="/servicios"><h3 class="card-title">Servicios basicos registrados</h3></a>
                          <h1 class="card-subtitle" style="text-align: end;">{{serviciosBasicosRegistrados}}</h1> </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- Column -->
      </div>
      <!-- Row -->

        </div>
      </div>

    </div>
  </div>
</div>
